// extracted by mini-css-extract-plugin
export default {"header":"hN-z","isActive":"iN-z"};